(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3823,107],{

/***/ 57311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _code_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(95627);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./src/utils/gtm/context.tsx + 3 modules
var context = __webpack_require__(26602);
// EXTERNAL MODULE: ./src/utils/gtm/mappers.ts + 2 modules
var mappers = __webpack_require__(29590);
// EXTERNAL MODULE: ./src/components/common/Head.tsx
var Head = __webpack_require__(26718);
// EXTERNAL MODULE: ./src/components/common/MetaTags.tsx
var MetaTags = __webpack_require__(71033);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/containers/data/brands.json
var brands = __webpack_require__(11669);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/NltOffer.tsx





const NltOffer = _ref => {
  let {
    offerData
  } = _ref;
  const data = {
    "@context": "https://schema.org/",
    "@type": "Vehicle",
    "name": `${offerData.vehicle.name} - Noleggio a Lungo Termine`,
    "image": offerData.images.map(image => image.src),
    "description": `${offerData.vehicle.name} a ${offerData.monthlyRate}€ al mese! Con CarPlanner hai manutenzione, assicurazione, bollo, tassa di proprietà a molti altri servizi, inclusi in un unico canone mensile.`,
    "sku": offerData.code,
    "mpn": offerData.id,
    "fuelType": offerData.vehicle.engine.fuel,
    "brand": {
      "@type": "Brand",
      "name": offerData.vehicle.brand,
      "logo": brands.find(brand => brand.href === offerData.vehicle.brandCode).image
    },
    "offers": {
      "@type": "Offer",
      "url": `https://www.carplanner.com/noleggio-a-lungo-termine/${offerData.vehicle.brandCode}/${offerData.vehicle.modelCode}/${offerData.code}`,
      "priceCurrency": 'EUR',
      "price": offerData.monthlyRate,
      "itemCondition": 'https://schema.org/NewCondition',
      "availability": 'https://schema.org/LimitedAvailability',
      "seller": {
        '@type': 'Organization',
        "name": "CarPlanner",
        "url": "https://www.carplanner.com/",
        "logo": "https://static1.carplanner.com/logos/carplanner.svg"
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataNltOffer",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_NltOffer = (NltOffer);
// EXTERNAL MODULE: ./src/uikit/Titles/H3.tsx
var H3 = __webpack_require__(89149);
// EXTERNAL MODULE: ./src/utils/dateUtils.js
var dateUtils = __webpack_require__(73119);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(58268);
;// CONCATENATED MODULE: ./pages/noleggio-a-lungo-termine/[landing]/[model]/[code].tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















const {
  formattedYear
} = (0,dateUtils/* getFormattedMonthYear */.P)();
const NltServiceContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 9702).then(__webpack_require__.bind(__webpack_require__, 99702)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(99702)]
  }
});
const BeforeNltSectionContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 4665).then(__webpack_require__.bind(__webpack_require__, 44665)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(44665)]
  }
});
const HowNltWorksSectionContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 3458).then(__webpack_require__.bind(__webpack_require__, 3458)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(3458)]
  }
});
const NltCustomizeOfferModalContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 9762).then(__webpack_require__.bind(__webpack_require__, 19762)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(19762)]
  }
});
const StickyBarContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 223).then(__webpack_require__.bind(__webpack_require__, 10223)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(10223)]
  }
});
const VehicleOptionalsContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 5035).then(__webpack_require__.bind(__webpack_require__, 15035)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(15035)]
  }
});
const VehicleDetailsContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 6980).then(__webpack_require__.bind(__webpack_require__, 76980)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(76980)]
  }
});
const SimilarOffersList = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7620), __webpack_require__.e(2732), __webpack_require__.e(6917), __webpack_require__.e(452)]).then(__webpack_require__.bind(__webpack_require__, 41869)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(41869)]
  }
});
const PartnershipBanner = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(135)]).then(__webpack_require__.bind(__webpack_require__, 70135)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(70135)]
  }
});
const Breadcrumbs = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(3053)]).then(__webpack_require__.bind(__webpack_require__, 33053)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(33053)]
  }
});
const OfferGalleryContainer = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7620), __webpack_require__.e(3049), __webpack_require__.e(4704)]).then(__webpack_require__.bind(__webpack_require__, 2451)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(2451)]
  }
});
const OfferDetailsContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 9827).then(__webpack_require__.bind(__webpack_require__, 69827)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(69827)]
  }
});

const NltOfferPage = _ref => {
  let {
    offerData,
    similarOffers,
    variationSearch,
    howNltWorksData
  } = _ref;
  const router = (0,next_router.useRouter)();
  const pathname = (0,url/* stripQueryString */.k)(router.asPath);
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const {
    0: similarOffersItems,
    1: setSimilarOffersItems
  } = (0,react.useState)([similarOffers.input]);

  if (variationSearch && variationSearch.contractLength && variationSearch.annualMileage && variationSearch.deposit) {
    let {
      contractLength,
      annualMileage,
      deposit
    } = variationSearch;
    contractLength = parseInt(contractLength);
    annualMileage = parseInt(annualMileage);
    deposit = parseInt(deposit);
    const newDefault = offerData.variations.find(variation => variation.contractLength === contractLength && variation.annualMileage === annualMileage && variation.deposit === deposit);

    if (newDefault) {
      const oldDefault = {
        id: offerData.id,
        contractLength: offerData.contractLength,
        annualMileage: offerData.annualMileage,
        deposit: offerData.deposit,
        monthlyRate: offerData.monthlyRate
      };
      offerData.contractLength = newDefault.contractLength;
      offerData.annualMileage = newDefault.annualMileage;
      offerData.deposit = newDefault.deposit;
      offerData.monthlyRate = newDefault.monthlyRate;
      offerData.variations = offerData.variations.filter(variation => variation.contractLength !== contractLength || variation.annualMileage !== annualMileage || variation.deposit !== deposit);
      offerData.variations.push(_objectSpread({}, oldDefault));
    }
  }

  const customizeModalIsOpen = (0,es/* useSelector */.v9)(state => state.nlt.customizeModalIsOpen);
  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0.5
  });
  (0,react.useEffect)(() => {
    const MATTIA_MIN_ZINDEX = 2147483640; // To change if we changes MattIA z-index

    const getMattiaElements = () => Array.from(document.body.children).filter(el => {
      if (!(el instanceof HTMLElement)) return false;
      const zIndex = parseInt(window.getComputedStyle(el).zIndex, 10);
      return !Number.isNaN(zIndex) && zIndex >= MATTIA_MIN_ZINDEX;
    });

    const hideElements = () => {
      getMattiaElements().forEach(el => {
        if (el.style.display !== 'none') el.style.display = 'none';
      });
    };

    let attributeObserver = null;

    const watchAttributes = () => {
      var _attributeObserver;

      const targets = getMattiaElements();
      if (!targets.length) return;
      (_attributeObserver = attributeObserver) === null || _attributeObserver === void 0 ? void 0 : _attributeObserver.disconnect();
      attributeObserver = new MutationObserver(hideElements);
      targets.forEach(el => attributeObserver.observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class']
      }));
    };

    const onBodyChange = () => {
      hideElements();
      watchAttributes();
    };

    onBodyChange();
    const bodyObserver = new MutationObserver(onBodyChange);
    bodyObserver.observe(document.body, {
      childList: true
    });
    return () => {
      var _attributeObserver2;

      bodyObserver.disconnect();
      (_attributeObserver2 = attributeObserver) === null || _attributeObserver2 === void 0 ? void 0 : _attributeObserver2.disconnect();
      getMattiaElements().forEach(el => {
        el.style.display = '';
      });
    };
  }, []);
  (0,react.useEffect)(() => {
    setSimilarOffersItems(similarOffers.predicted);
  }, [similarOffers]);
  const crumbs = [{
    page: 'Home Page',
    href: '/',
    title: 'Home Page'
  }, {
    page: 'Offerte Noleggio a Lungo Termine',
    href: '/noleggio-a-lungo-termine',
    title: 'Offerte Noleggio a Lungo Termine'
  }, {
    page: `${offerData.vehicle.brand}`,
    href: `/noleggio-a-lungo-termine/${offerData.vehicle.brandCode}`,
    title: `${offerData.vehicle.brand}`
  }, {
    page: `${offerData.vehicle.model}`,
    href: `/noleggio-a-lungo-termine/${offerData.vehicle.brandCode}/${offerData.vehicle.modelCode}`,
    title: `${offerData.vehicle.model}`
  }, {
    page: `${offerData.code}`,
    href: pathname,
    title: `${offerData.code}`
  }];
  const formattedMetaDataTitle = (0,dateUtils/* replaceDatePlaceholders */.h)(offerData.metaDataTitle);
  const formattedMetaDataDescription = (0,dateUtils/* replaceDatePlaceholders */.h)(offerData.metaDataDescription);
  const pageTitle = formattedMetaDataTitle || t('nltPage:landingModel.title', {
    brand: offerData.vehicle.brand,
    model: offerData.vehicle.model,
    description: offerData.vehicle.version,
    fuel: offerData.vehicle.engine.fuel,
    year: formattedYear
  });
  (0,context/* useGtmPage */.Z)((0,mappers/* rentOfferToPageMeta */.tH)(offerData, {
    path: router.asPath,
    pageTitle
  }));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: "2684451489",
      children: ["#CookiebotWidget{z-index:1 !important;}"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Head/* default */.Z, {
      title: pageTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
      meta: t(`nltPage:landingModel.meta`, {
        returnObjects: true,
        brand: offerData.vehicle.brand,
        model: offerData.vehicle.model,
        description: offerData.vehicle.version,
        fuel: offerData.vehicle.engine.fuel,
        price: offerData.monthlyRate,
        numMonths: offerData.contractLength,
        metaDataDescription: formattedMetaDataDescription,
        url: `https://www.carplanner.com${pathname}`
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* LinkRel */.M, {
      rel: "canonical",
      href: `https://www.carplanner.com${pathname}`
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StructuredData_NltOffer, {
      offerData: offerData
    }), offerData.partnership && /*#__PURE__*/(0,jsx_runtime.jsx)(PartnershipBanner, {
      partner: offerData.partnership
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
      maxW: "8xl",
      px: {
        base: '1.375rem',
        md: null
      },
      ref: ref,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        display: {
          base: 'none',
          md: 'flex'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs, {
          items: crumbs
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        mb: "8",
        display: {
          base: 'block',
          md: 'none'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OfferGalleryContainer, {
          images: offerData.images,
          badge: offerData.mainTag
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetailsContainer, {
          offerData: offerData
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
        templateColumns: "2fr 1fr",
        gap: 4,
        display: {
          base: 'none',
          md: 'grid'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferGalleryContainer, {
            images: offerData.images,
            badge: offerData.mainTag
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetailsContainer, {
            offerData: offerData
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltServiceContainer, {
      title: t('productPage:services.title'),
      services: offerData.services
    }), offerData.description && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      bg: "baseWhite",
      pb: "xxl6",
      mt: "xxl6",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
        maxW: "7xl",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(H3/* default */.Z, {
          children: t('productPage:services.offerDescription')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          as: "div",
          textAlign: "left",
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "1rem",
          letterSpacing: "0.2px",
          lineHeight: "20.8px",
          dangerouslySetInnerHTML: {
            __html: offerData.description
          }
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetailsContainer, {
      vehicle: offerData.vehicle,
      title: t('productPage:vehicleDetails.title', {
        value: `${offerData.vehicle.name} ${offerData.vehicle.version}`
      })
    }), offerData.features.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleOptionalsContainer, {
      optionals: offerData.features
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HowNltWorksSectionContainer, {
      content: howNltWorksData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BeforeNltSectionContainer, {}), similarOffersItems && similarOffersItems.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SimilarOffersList, {
      title: t('productPage:similarOffersTitle'),
      action: t('indexPage:nlt_offers.action'),
      alt: t('indexPage:nlt_offers.alt'),
      bgColor: "baseNeutral.100",
      href: "/noleggio-a-lungo-termine",
      offers: similarOffersItems,
      numPerView: 4
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(StickyBarContainer, {
      offerData: offerData,
      visible: !inView
    }), customizeModalIsOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(NltCustomizeOfferModalContainer, {
      offerData: offerData
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _code_ = (NltOfferPage);

/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Head = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[0].image */ .qk[0].image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[1].image */ .qk[1].image
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Head);

/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkRel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const isMetaTag = value => {
  if (!value || typeof value !== 'object') return false;
  const tag = value;
  const hasNameOrProperty = typeof tag.name === 'string' || typeof tag.property === 'string';
  if (!hasNameOrProperty) return false;
  const contentOk = tag.content === undefined || typeof tag.content === 'string';
  const overrideOk = tag.override === undefined || typeof tag.override === 'string';
  return contentOk && overrideOk;
};

const normalizeMeta = meta => {
  if (!meta) return [];

  if (Array.isArray(meta)) {
    return meta.filter(isMetaTag);
  }

  if (isMetaTag(meta)) {
    return [meta];
  }

  if (typeof meta === 'object') {
    return Object.values(meta).filter(isMetaTag);
  }

  return [];
};

const MetaTags = _ref => {
  let {
    meta
  } = _ref;
  const tags = normalizeMeta(meta);
  if (tags.length === 0) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: tags.map((tag, index) => {
      const content = tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? '';
      const key = tag.name ?? tag.property ?? `meta-${index}`;

      if (tag.name) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          name: tag.name,
          content: content
        }, key);
      }

      if (tag.property) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          property: tag.property,
          content: content
        }, key);
      }

      return null;
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);
const LinkRel = _ref2 => {
  let {
    rel,
    href,
    crossOrigin,
    type,
    as
  } = _ref2;
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    url = href.split('?')[0] ?? '';
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};

/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const H3 = _ref => {
  let {
    children
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, _objectSpread(_objectSpread({
    as: "h3",
    marginBottom: "xxl4",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.75rem",
    lineHeight: "2.275rem"
  }, others), {}, {
    color: "baseDark",
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (H3);

/***/ }),

/***/ 73119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getFormattedMonthYear; },
/* harmony export */   "h": function() { return /* binding */ replaceDatePlaceholders; }
/* harmony export */ });
const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', {
  month: 'long',
  year: 'numeric'
});
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();
const getFormattedMonthYear = () => {
  return {
    formattedMonth,
    formattedYear
  };
};
const replaceDatePlaceholders = text => {
  if (!text) return null; // Fallback se il testo è null o undefined

  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};

/***/ }),

/***/ 29590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tH": function() { return /* binding */ rentOfferToPageMeta; },
  "ck": function() { return /* binding */ rentOfferToProductItem; },
  "np": function() { return /* binding */ sellOfferToPageMeta; },
  "rW": function() { return /* binding */ sellOfferToProductItem; }
});

// UNUSED EXPORTS: rentOfferToOfferData, rentOfferValue, sellOfferToOfferData, sellOfferValue, toNumber

// EXTERNAL MODULE: ./src/utils/gtm/constants.ts
var constants = __webpack_require__(98845);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/utils/gtm/naming.ts
var naming = __webpack_require__(31067);
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.json
var brandRules_namespaceObject = JSON.parse('{"fiat":{"rpl":22,"offerCustomerType":"B2C","offerType":"Finanziamento"},"jeep":{"rpl":27.5,"offerCustomerType":"B2C","offerType":"Finanziamento"},"bmw":{"offerCustomerType":"B2C","offerType":"Leasing"},"toyota":{"offerCustomerType":"B2B","offerType":"Finanziamento"},"peugeot":{"offerCustomerType":"B2C","offerType":"Finanziamento"}}');
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Valori commerciali che variano per brand automotive.
 *
 * Oggi vivono in un JSON versionato ([brandRules.json](./brandRules.json)): sono
 * accordi commerciali che cambiano di rado e che il backend non espone. La
 * lettura passa da `getBrandRules`, così che il giorno in cui l'offers-explorer
 * restituirà questi campi basti cambiare questa implementazione senza toccare
 * i punti di chiamata.
 *
 * Un brand non mappato NON eredita un rpl inventato: la chiave viene omessa.
 */



const DEFAULT_RULES = {
  offerCustomerType: 'B2C',
  offerType: constants/* DEFAULT_OFFER_TYPE */.OJ
};
function getBrandRules(brandCode) {
  const key = (0,naming/* slugSegment */.nL)(brandCode);
  const brandRules = key ? brandRules_namespaceObject[key] : undefined;
  return _objectSpread(_objectSpread({}, DEFAULT_RULES), brandRules);
}
;// CONCATENATED MODULE: ./src/utils/gtm/mappers.ts
/**
 * Dai DTO dell'offers-explorer agli oggetti dello schema dataLayer.
 *
 * Attenzione alla semantica dei prezzi, invertita rispetto a quella intuitiva:
 * `ecommerce.items[].price` è il prezzo di LISTINO, mentre `ecommerce.value` è
 * il prezzo promozionale/corrente. GA4 non sottrae mai `discount` da `price`.
 */



/** Converte in numero positivo; qualunque altro caso diventa `undefined` (chiave omessa). */
function toNumber(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const parsed = typeof value === 'number' ? value : parseFloat(`${value}`);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

const absoluteUrl = path => path ? `${constants/* SITE_ORIGIN */.yp}${path.split('?')[0].split('#')[0]}` : undefined;

const withQuery = path => path ? `${constants/* SITE_ORIGIN */.yp}${path}` : undefined;

const sellOfferPath = offer => {
  var _offer$vehicle, _offer$vehicle2;

  return `/offerte-auto/${((_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.brandCode) ?? offer.brandCode}/${((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.modelCode) ?? offer.modelCode}/${offer.code}`;
};

const rentOfferPath = offer => {
  var _offer$vehicle3, _offer$vehicle4;

  return `/noleggio-a-lungo-termine/${((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.brandCode) ?? offer.brandCode}/${((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.modelCode) ?? offer.modelCode}/${offer.code}`;
};

function sellOfferToProductItem(offer) {
  var _vehicle$engine;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? offer.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine = vehicle.engine) === null || _vehicle$engine === void 0 ? void 0 : _vehicle$engine.fuel;
  const canonicalPath = path || sellOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: vehicle === null || vehicle === void 0 ? void 0 : vehicle.category,
    item_category4: detail.year ? `${detail.year}` : undefined,
    item_category5: version,
    price: toNumber(offer.price),
    currency: constants/* CURRENCY */.wA,
    discount: toNumber(detail.priceReduction),
    image_url: detail.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function rentOfferToProductItem(offer) {
  var _vehicle$engine2, _detail$images, _detail$images$;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const item = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? item.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? item.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? item.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine2 = vehicle.engine) === null || _vehicle$engine2 === void 0 ? void 0 : _vehicle$engine2.fuel;
  const canonicalPath = path || rentOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category) ?? item.category,
    item_category5: version,
    // Il noleggio non espone un prezzo di listino del veicolo: resta omesso.
    price: toNumber(detail.specialPrice),
    currency: constants/* CURRENCY */.wA,
    image_url: ((_detail$images = detail.images) === null || _detail$images === void 0 ? void 0 : (_detail$images$ = _detail$images[0]) === null || _detail$images$ === void 0 ? void 0 : _detail$images$.src) ?? item.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function sellOfferToOfferData(offer) {
  var _offer$vehicle5;

  const brandCode = ((_offer$vehicle5 = offer.vehicle) === null || _offer$vehicle5 === void 0 ? void 0 : _offer$vehicle5.brandCode) ?? offer.brandCode;
  const rules = getBrandRules(brandCode);
  return {
    offer_type: rules.offerType,
    offer_customer_type: rules.offerCustomerType,
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
function rentOfferToOfferData(offer) {
  return {
    offer_type: constants/* RENT_OFFER_TYPE */.y,
    offer_customer_type: offer.customerType === 'piva' ? 'B2B' : 'B2C',
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
/** Prezzo promozionale/corrente del veicolo. */

const sellOfferValue = offer => toNumber(offer.specialPrice) ?? toNumber(offer.price);
/** Per il noleggio l'unico valore economico esposto è il canone mensile. */

const rentOfferValue = offer => toNumber(offer.monthlyRate);

/** Meta di pagina per la VDP sell, pronta per `useGtmPage`. */
function sellOfferToPageMeta(offer) {
  var _vehicle$engine3;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  const brandCode = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode) ?? offer.brandCode;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand,
    model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine3 = vehicle.engine) === null || _vehicle$engine3 === void 0 ? void 0 : _vehicle$engine3.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(brandCode).rpl,
    productItem: sellOfferToProductItem(offer, {
      path
    }),
    offerData: sellOfferToOfferData(offer),
    value: sellOfferValue(offer)
  };
}
/** Meta di pagina per la VDP noleggio, pronta per `useGtmPage`. */

function rentOfferToPageMeta(offer) {
  var _vehicle$engine4;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand,
    model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine4 = vehicle.engine) === null || _vehicle$engine4 === void 0 ? void 0 : _vehicle$engine4.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode).rpl,
    productItem: rentOfferToProductItem(offer, {
      path
    }),
    offerData: rentOfferToOfferData(offer),
    value: rentOfferValue(offer)
  };
}

/***/ }),

/***/ 58268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ stripQueryString; }
/* harmony export */ });
/* unused harmony export isExternalLink */
const isExternalLink = href => {
  if (!href) return false; // Absolute URLs (http/https) or protocol-relative URLs (//...)

  return href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//');
};
const stripQueryString = path => path.split(/[?#]/)[0];

/***/ }),

/***/ 99249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine/[landing]/[model]/[code]",
      function () {
        return __webpack_require__(57311);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 11669:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"href":"alfa-romeo","image":"https://static1.carplanner.com/cars/brands/alfa-romeo.svg","name":"Alfa Romeo","slug":"ALF"},{"href":"abarth","image":"https://static1.carplanner.com/cars/brands/abarth.svg","name":"Abarth","slug":"ABA"},{"href":"aston-martin","image":"https://static1.carplanner.com/cars/brands/aston-martin.svg","name":"Aston Martin","slug":"AST"},{"href":"audi","image":"https://static1.carplanner.com/cars/brands/audi.svg","name":"Audi","slug":"AUD"},{"href":"bentley","image":"https://static1.carplanner.com/cars/brands/bentley.svg","name":"Bentley","slug":"BEN"},{"href":"bmw","image":"https://static1.carplanner.com/cars/brands/bmw.svg","name":"BMW","slug":"BMW"},{"href":"byd","image":"https://static1.carplanner.com/cars/brands/byd.svg","name":"BYD","slug":"BYD"},{"href":"cadillac","image":"https://static1.carplanner.com/cars/brands/cadillac.svg","name":"Cadillac","slug":"CAD"},{"href":"chevrolet","image":"https://static1.carplanner.com/cars/brands/chevrolet.svg","name":"Chevrolet","slug":"CHC"},{"href":"chrysler","image":"https://static1.carplanner.com/cars/brands/chrysler.svg","name":"Chrysler","slug":"CHR"},{"href":"citroen","image":"https://static1.carplanner.com/cars/brands/citroen.svg","name":"Citroen","slug":"CIT"},{"href":"cupra","image":"https://static1.carplanner.com/cars/brands/cupra.svg","name":"Cupra","slug":"CUP"},{"href":"dacia","image":"https://static1.carplanner.com/cars/brands/dacia.svg","name":"Dacia","slug":"DAC"},{"href":"dr","image":"https://static1.carplanner.com/cars/brands/dr.svg","name":"DR","slug":"DRM"},{"href":"ds","image":"https://static1.carplanner.com/cars/brands/ds.svg","name":"DS","slug":"DSA"},{"href":"ferrari","image":"https://static1.carplanner.com/cars/brands/ferrari.svg","name":"Ferrari","slug":"FER"},{"href":"fiat","image":"https://static1.carplanner.com/cars/brands/fiat.svg","name":"Fiat","slug":"FIA"},{"href":"ford","image":"https://static1.carplanner.com/cars/brands/ford.svg","name":"Ford","slug":"FOR"},{"href":"honda","image":"https://static1.carplanner.com/cars/brands/honda.svg","name":"Honda","slug":"HON"},{"href":"hyundai","image":"https://static1.carplanner.com/cars/brands/hyundai.svg","name":"Hyundai","slug":"HYU"},{"href":"infiniti","image":"https://static1.carplanner.com/cars/brands/infiniti.svg","name":"Infiniti","slug":"INF"},{"href":"jaguar","image":"https://static1.carplanner.com/cars/brands/jaguar.svg","name":"Jaguar","slug":"JAG"},{"href":"jaecoo","image":"https://static1.carplanner.com/cars/brands/jaecoo.svg","name":"Jaecoo","slug":"JAE"},{"href":"jeep","image":"https://static1.carplanner.com/cars/brands/jeep.svg","name":"Jeep","slug":"JEE"},{"href":"kia","image":"https://static1.carplanner.com/cars/brands/kia.svg","name":"Kia","slug":"KIA"},{"href":"lamborghini","image":"https://static1.carplanner.com/cars/brands/lamborghini.svg","name":"Lamborghini","slug":"LAM"},{"href":"lancia","image":"https://static1.carplanner.com/cars/brands/lancia.svg","name":"Lancia","slug":"LAN"},{"href":"land-rover","image":"https://static1.carplanner.com/cars/brands/land-rover.svg","name":"Land Rover","slug":"LND"},{"href":"leapmotor","image":"https://static1.carplanner.com/cars/brands/leapmotor.svg","name":"Leap Motor","slug":"LEA"},{"href":"lexus","image":"https://static1.carplanner.com/cars/brands/lexus.svg","name":"Lexus","slug":"LEX"},{"href":"lotus","image":"https://static1.carplanner.com/cars/brands/lotus.svg","name":"Lotus","slug":"LOT"},{"href":"mahindra","image":"https://static1.carplanner.com/cars/brands/mahindra.svg","name":"Mahindra","slug":"MAH"},{"href":"maserati","image":"https://static1.carplanner.com/cars/brands/maserati.svg","name":"Maserati","slug":"MAS"},{"href":"mazda","image":"https://static1.carplanner.com/cars/brands/mazda.svg","name":"Mazda","slug":"MAZ"},{"href":"mclaren","image":"https://static1.carplanner.com/cars/brands/mclaren.svg","name":"McLaren","slug":"MCL"},{"href":"mercedes","image":"https://static1.carplanner.com/cars/brands/mercedes.svg","name":"Mercedes-Benz","slug":"MER"},{"href":"mg","image":"https://static1.carplanner.com/cars/brands/mg.svg","name":"MG","slug":"MGG"},{"href":"mini","image":"https://static1.carplanner.com/cars/brands/mini.svg","name":"Mini","slug":"MIN"},{"href":"mitsubishi","image":"https://static1.carplanner.com/cars/brands/mitsubishi.svg","name":"Mitsubishi","slug":"MIT"},{"href":"nissan","image":"https://static1.carplanner.com/cars/brands/nissan.svg","name":"Nissan","slug":"NIS"},{"href":"omoda","image":"https://static1.carplanner.com/cars/brands/omoda.svg","name":"Omoda","slug":"OMO"},{"href":"opel","image":"https://static1.carplanner.com/cars/brands/opel.svg","name":"Opel","slug":"OPE"},{"href":"peugeot","image":"https://static1.carplanner.com/cars/brands/peugeot.svg","name":"Peugeot","slug":"PEU"},{"href":"porsche","image":"https://static1.carplanner.com/cars/brands/porsche.svg","name":"Porsche","slug":"POR"},{"href":"renault","image":"https://static1.carplanner.com/cars/brands/renault.svg","name":"Renault","slug":"REN"},{"href":"rolls-royce","image":"https://static1.carplanner.com/cars/brands/rolls-royce.svg","name":"Rolls-Royce","slug":"ROL"},{"href":"seat","image":"https://static1.carplanner.com/cars/brands/seat.svg","name":"Seat","slug":"SEA"},{"href":"skoda","image":"https://static1.carplanner.com/cars/brands/skoda.svg","name":"Skoda","slug":"SKO"},{"href":"smart","image":"https://static1.carplanner.com/cars/brands/smart.svg","name":"Smart","slug":"SMA"},{"href":"ssangyong","image":"https://static1.carplanner.com/cars/brands/ssangyong.svg","name":"Ssangyong","slug":"SAN"},{"href":"subaru","image":"https://static1.carplanner.com/cars/brands/subaru.svg","name":"Subaru","slug":"SUB"},{"href":"suzuki","image":"https://static1.carplanner.com/cars/brands/suzuki.svg","name":"Suzuki","slug":"SUZ"},{"href":"tesla","image":"https://static1.carplanner.com/cars/brands/tesla.svg","name":"Tesla","slug":"TES"},{"href":"toyota","image":"https://static1.carplanner.com/cars/brands/toyota.svg","name":"Toyota","slug":"TOY"},{"href":"volkswagen","image":"https://static1.carplanner.com/cars/brands/volkswagen.svg","name":"Volkswagen","slug":"VLK"},{"href":"volvo","image":"https://static1.carplanner.com/cars/brands/volvo.svg","name":"Volvo","slug":"VOL"}]');

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Offerte noleggio a lungo termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Offerte auto in vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7650,9774,2888,179], function() { return __webpack_exec__(99249); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);